export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16" data-testid="privacy-page">
      <div className="overline mb-4">Privacy</div>
      <h1 className="font-serif text-4xl md:text-5xl font-semibold tracking-tight">Privacy Policy</h1>
      <div className="mt-8 space-y-5 text-base leading-relaxed text-foreground/85">
        <p>YUMO collects only the information you choose to share — your name, email, food preferences, taste DNA, and the recommendations you act on — to make your food decisions better.</p>
        <p>We never sell your data. We never sell your taste profile. The signals you give us are used to refine your personal recommendations.</p>
        <p>You can delete your account and your stored Taste DNA at any time by writing to us at <a href="mailto:yumoaifoods@gmail.com" className="text-primary underline underline-offset-4">yumoaifoods@gmail.com</a>.</p>
        <p>This page will be expanded as YUMO evolves. For specific questions, please email us.</p>
      </div>
    </div>
  );
}
